import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/partners/surrogacy-agency-partnership/#webpage",
   "url": "https://www.futurefamilyai.com/partners/surrogacy-agency-partnership/",
   "name": "Surrogacy Agency Wellness App Partnership | FutureFamilyAI",
   "description": "Give surrogates a supportive, privacy-first wellness option. Voluntary enrollment, coordinator logistics and surrogate-controlled sharing.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Partner Directory",
     "item": "https://www.futurefamilyai.com/partners/directory/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Surrogacy Agency Partnership",
     "item": "https://www.futurefamilyai.com/partners/surrogacy-agency-partnership/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Is FutureFamilyAI used by surrogacy agencies?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Surrogacy4All uses FutureFamilyAI to support its surrogates."
     }
    },
    {
     "@type": "Question",
     "name": "Is enrollment mandatory for surrogates?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No, it's voluntary."
     }
    },
    {
     "@type": "Question",
     "name": "Can intended parents see surrogate data?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Only with the surrogate's permission."
     }
    },
    {
     "@type": "Question",
     "name": "What does it cost the agency?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No partner fees."
     }
    },
    {
     "@type": "Question",
     "name": "Who supports surrogates technically?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "The FutureFamilyAI care team."
     }
    },
    {
     "@type": "Question",
     "name": "Can we co-brand materials?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, on request."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function PartnersSurrogacyAgencyPartnershipPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/partners/directory">Partner Directory</Link>
              <span>›</span>
              <span>Surrogacy Agency Partnership</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                A surrogacy agency partnership with FutureFamilyAI offers
                surrogates a voluntary, privacy-first wellness program with
                validated-cuff blood pressure, smartwatch trends and care-team
                review.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Surrogacy agencies</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Hypertensive disorders were present in about 1 in 7 U.S.
                      delivery hospitalizations (2017–2019). (CDC, MMWR 2022)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Used by Surrogacy4All · Voluntary, surrogate-controlled ·
                      No fees
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">PARTNER NETWORK</span>
            <h1>Surrogacy Agency Partnership — A Privacy-First Option</h1>
            <p className="ffh-answer speakable-content">
              A surrogacy agency partnership with FutureFamilyAI offers
              surrogates a voluntary, privacy-first wellness program with
              validated-cuff blood pressure, smartwatch trends and care-team
              review. Coordinators help with logistics; medical decisions stay
              with clinicians; intended parents see only what the surrogate
              authorizes. Surrogacy4All already uses FutureFamilyAI for its
              surrogates. Partnerships carry no fees, and the FutureFamilyAI
              care team handles surrogate setup questions. Request an agency
              pilot.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/partners/join-referral-network"
              >
                Join the Partner Network — No Fees
              </Link>
              <Link
                className="ffh-btn ffh-ghost"
                to="/contact-us?type=physician"
              >
                Request a Clinical Demo
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Surrogacy agency coordinator meeting a surrogate about wellness support"
              >
                <figcaption>
                  <b>Photo slot</b> · Agency coordinator and surrogate having
                  coffee together at a café, warm rapport, natural light. No
                  logos.
                  <br />
                  <b>Alt:</b> Surrogacy agency coordinator meeting a surrogate
                  about wellness support
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Hypertensive disorders were present in about 1 in 7 U.S.
                    delivery hospitalizations (2017–2019).
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/mmwr/volumes/71/wr/mm7117a1.htm">
                        CDC, MMWR 2022
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>What your agency gets</h2>
                <ul>
                  <li>Surrogate onboarding support</li>
                  <li>Coordinator logistics view</li>
                  <li>Intended-parent summaries with consent</li>
                  <li>Directory listing</li>
                </ul>
              </section>
              <section id="s2">
                <h2>Principles</h2>
                <ul>
                  <li>Participation is voluntary</li>
                  <li>Surrogate controls data</li>
                  <li>Clinicians make medical decisions</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>No partner fees. Our care team handles patient setup.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/partners/join-referral-network"
                >
                  Join the Partner Network — No Fees
                </Link>
              </div>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      Is FutureFamilyAI used by surrogacy agencies?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Yes. Surrogacy4All uses FutureFamilyAI to support its
                        surrogates.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is enrollment mandatory for surrogates?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>No, it&apos;s voluntary.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Can intended parents see surrogate data?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>Only with the surrogate&apos;s permission.</p>
                    </div>
                  </details>
                  <details>
                    <summary>What does it cost the agency?</summary>
                    <div className="ffh-ans">
                      <p>No partner fees.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Who supports surrogates technically?</summary>
                    <div className="ffh-ans">
                      <p>The FutureFamilyAI care team.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Can we co-brand materials?</summary>
                    <div className="ffh-ans">
                      <p>Yes, on request.</p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/partners/join-referral-network"
                  >
                    Join the Partner Network — No Fees
                  </Link>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=physician"
                  >
                    Request a Clinical Demo
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">RG</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Rashmi Gulati, MD</h3>
                  <p>
                    Medical Director, Patients Medical. Dr. Rashmi Gulati, MD,
                    is Medical Director of Patients Medical, a Manhattan
                    practice founded in 1974. She leads FutureFamilyAI&apos;s
                    physician and care-team content and medically reviews every
                    page on this site.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/partners/directory">Partner Directory →</Link>
                  <Link to="/partners">For IVF Clinics &amp; Agencies →</Link>
                  <Link to="/partners/join-referral-network">
                    Join Referral Network →
                  </Link>
                  <Link to="/partners/ivf-clinic-partnership">
                    IVF Clinic Partnership →
                  </Link>
                  <Link to="/partners/no-fee-directory-faq">
                    No-Fee Directory FAQ →
                  </Link>
                  <Link to="/partners/find-a-provider">Find a Provider →</Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.surrogacy4all.com">
                    https://www.surrogacy4all.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">What your agency gets</a>
                  </li>
                  <li>
                    <a href="#s2">Principles</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Partner with FutureFamilyAI</b>
                <span>No fees. Free directory listing.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/partners/join-referral-network"
                >
                  Join the Partner Network — No Fees
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
